import { useState } from 'react'
import type { FormEvent } from 'react'
import { BladApi } from '../dane/api.js'
import { useSesja } from '../dane/sesja.js'
import { Pole } from '../ui/Pole.js'
import { Przycisk } from '../ui/Przycisk.js'
import './logowanie.css'

export function Logowanie() {
  const { zaloguj } = useSesja()
  const [email, ustawEmail] = useState('')
  const [haslo, ustawHaslo] = useState('')
  const [blad, ustawBlad] = useState<string | null>(null)
  const [pracuje, ustawPracuje] = useState(false)

  async function wyslij(zdarzenie: FormEvent) {
    zdarzenie.preventDefault()
    ustawBlad(null)
    ustawPracuje(true)
    try {
      await zaloguj(email, haslo)
    } catch (problem) {
      ustawBlad(
        problem instanceof BladApi ? problem.message : 'Nie udało się połączyć z serwerem',
      )
    } finally {
      ustawPracuje(false)
    }
  }

  return (
    <div className="logowanie">
      <form className="logowanie__karta karta" onSubmit={wyslij}>
        <p className="logowanie__marka">
          Budżet<span>firmy</span>
        </p>
        <h1 className="logowanie__tytul">Zaloguj się</h1>

        <div className="logowanie__pola">
          <Pole
            etykieta="Adres e-mail"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(zdarzenie) => ustawEmail(zdarzenie.target.value)}
          />
          <Pole
            etykieta="Hasło"
            type="password"
            autoComplete="current-password"
            required
            value={haslo}
            onChange={(zdarzenie) => ustawHaslo(zdarzenie.target.value)}
          />
        </div>

        {blad !== null ? (
          <p className="logowanie__blad" role="alert">
            {blad}
          </p>
        ) : null}

        <Przycisk type="submit" wariant="glowny" pracuje={pracuje}>
          {pracuje ? 'Logowanie…' : 'Zaloguj'}
        </Przycisk>
      </form>
    </div>
  )
}
